import { render, staticRenderFns } from "./unit-management.vue?vue&type=template&id=a83b43da&scoped=true"
import script from "./unit-management.vue?vue&type=script&lang=js"
export * from "./unit-management.vue?vue&type=script&lang=js"
import style0 from "./unit-management.vue?vue&type=style&index=0&id=a83b43da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83b43da",
  null
  
)

export default component.exports